import React from "react";

/**
 * Barra de progresso visual para formulários longos.
 * Mostra quantos campos essenciais foram preenchidos e o que ainda falta.
 *
 * Props:
 *  - items: Array<{ key, label, ok }> — lista de campos essenciais
 *  - testId: ID opcional para automação
 *  - readyLabel: texto exibido quando 100% completo (default: "Tudo pronto para salvar")
 */
export function FormProgress({ items, testId = "form-progress", readyLabel = "Tudo pronto para salvar" }) {
  const done = items.filter((i) => i.ok).length;
  const total = items.length || 1;
  const pct = Math.round((done / total) * 100);
  const complete = done === total;

  return (
    <div className="mt-3 mb-1" data-testid={testId}>
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">
          {complete ? `✓ ${readyLabel}` : `Campos essenciais ${done}/${total}`}
        </span>
        <span className={`text-[11px] font-bold ${complete ? "text-emerald-600" : "text-blue-600"}`}>
          {pct}%
        </span>
      </div>
      <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-300 ${complete ? "bg-emerald-500" : "bg-blue-500"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {!complete && (
        <div className="flex flex-wrap gap-1 mt-1.5">
          {items
            .filter((i) => !i.ok)
            .map((i) => (
              <span
                key={i.key}
                className="text-[10px] px-1.5 py-0.5 rounded-full bg-amber-50 border border-amber-200 text-amber-800"
              >
                ⚠ {i.label}
              </span>
            ))}
        </div>
      )}
    </div>
  );
}
